import { render, staticRenderFns } from "./NuezCard.vue?vue&type=template&id=18b6ee3e&"
import script from "./NuezCard.vue?vue&type=script&lang=ts&"
export * from "./NuezCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports